import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThemeProvider } from 'react-jss';

import optimizely, { optimizelyFeatures } from 'api/optimizely';
import { getPalette } from 'store/reducers/palette';
import { setPalette } from 'actions/palette-actions';
import theme from '../theme';

// We need to connect the ThemeProvider to the store
const Theme = ({ children }) => {
  const dispatch = useDispatch();
  const palette = useSelector(getPalette);
  useEffect(() => {
    const variant = optimizely.getFeatureVariable(optimizelyFeatures.DARK_THEME, 'variant');

    if (variant) {
      dispatch(setPalette(variant));
    }
  }, []);

  return <ThemeProvider theme={theme(palette)}>{children}</ThemeProvider>;
};

export default Theme;
